import * as React from 'react';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

import {Text} from './Text';

interface IBlockHeader {
  title: string;
  pretitle?: string;
  colour: string;
  img?: string | IGatsbyImageData;
  imgAlt?: string;
  imgStyling?: string;
  children?: React.ReactNode;
  id?: string;
}

export const BlockHeader = ({
  title,
  pretitle,
  colour,
  img,
  imgAlt,
  imgStyling,
  children,
  id,
}: IBlockHeader) => {
  return (
    <div id={id} className={`pt-12 text-black ${colour}`}>
      <div
        className={`flex flex-col-reverse lg:flex-row justify-between max-w-screen-xl items-center py-8 md:py-16 mx-8 lg:mx-28 xl:mx-40 2xl:mx-auto lg:gap-6 gap-2`}>
        <div className="lg:w-1/2 pt-6">
          {pretitle && (
            <p className="text-body font-semibold text-center lg:text-left">
              {pretitle}
            </p>
          )}
          <Text
            as="h1"
            variant="LargeTitle"
            className="pb-4 lg:pb-6 pt-2 lg:pt-3 text-center lg:text-left">
            {title}
          </Text>
          {children}
        </div>

        <div className="w-full lg:w-1/2">
          {img && typeof img === 'string' && (
            <img
              src={img}
              className={`ml-auto sm:max-w-[28rem] xl:max-w-[32rem] rounded-[2rem] object-cover ${imgStyling}`}
              alt={imgAlt ? imgAlt : `an image of ${img}`}
            />
          )}
          {img && typeof img !== 'string' && (
            <GatsbyImage
              image={img}
              objectFit="cover"
              className={`w-full ml-auto sm:max-w-[28rem] xl:max-w-[32rem] rounded-[2rem] ${imgStyling}`}
              alt={imgAlt ? imgAlt : ''}
            />
          )}
        </div>
      </div>
    </div>
  );
};
